// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import styled from 'styled-components';

import { baseSpacing, baseStyles } from '../Base';

export const StyledSubLabel = styled.p`
  color: ${(props) => props.theme.inputs.labelColor};
  font-size: ${(props) => props.theme.fontSizes.exSmall.fontSize};
  font-weight: ${(props) => props.theme.fontSizes.exSmall.fontWeight};
  line-height: ${(props) => props.theme.fontSizes.exSmall.lineHeight};

  ${baseSpacing}
  ${baseStyles}
`;
